export default __webpack_public_path__ + "locales/el-GR/PortalUnavailable.json?hash=501942fc0a47e3ae3ceec9285f8b517c";